import AbstractTaxonomyModel from './AbstractTaxonomyModel';
import doc                   from '@widesk-core/decorators/doc';
import { Translatable }      from '@widesk-core/decorators/translatable';
import { getLocale }         from '@widesk-core/locale';
import { RenderNameProps }   from '@widesk-ui/mixins/ApiModelRenderName';
import CustomTag             from '@/components/CustomTag';

@doc.urnResource('taxonomy')
@doc.translatable({ description: true, label: true })
class TaxonomyModel extends AbstractTaxonomyModel {
	public renderName(props?: RenderNameProps<this> & TaxonomyNameProps) {
		return super.renderName(props);
	}

	public get description() {
		return this.translation('description', getLocale());
	}

	public get customTag() {
		return CustomTag;
	}
}

interface TaxonomyModel
	extends Translatable<{ description: true, label: true }> {
}

export default TaxonomyModel;